__turbopack_context__.v({
  "container": "FeatureCard-module-scss-module__Fh8Jxq__container",
  "content": "FeatureCard-module-scss-module__Fh8Jxq__content",
  "description": "FeatureCard-module-scss-module__Fh8Jxq__description",
  "ellipse": "FeatureCard-module-scss-module__Fh8Jxq__ellipse",
  "imageWrapper": "FeatureCard-module-scss-module__Fh8Jxq__imageWrapper",
  "link": "FeatureCard-module-scss-module__Fh8Jxq__link",
  "listItem": "FeatureCard-module-scss-module__Fh8Jxq__listItem",
  "listWrapper": "FeatureCard-module-scss-module__Fh8Jxq__listWrapper",
  "primary": "FeatureCard-module-scss-module__Fh8Jxq__primary",
  "secondary": "FeatureCard-module-scss-module__Fh8Jxq__secondary",
});
